import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import Button from "../base/Button";
import ClickableText from "../base/ClickableText";
import Modal from "../modal/Modal";
import InputField from "../input-field/InputField";
import { useEmailStore } from "../store/emailStore";
import Spinner from "../base/Spinner";
import { useToastWrapper } from "../../hooks/useToastWrapper";
import { useLocalizedString } from "@amzn/aws-marketing-identity-kit-localizations";
import { Sanitize } from "../Sanitize";
const RemoveEmailModal = ({ isOpen, onEmailRemoved, profile, adapter, email, onClose, }) => {
    const [emailToRemove, setEmailToRemove] = useState("");
    const [removeError, setRemoveError] = useState("");
    const [isValidating, setIsValidationg] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const { removeEmail, updateInitialEmails } = useEmailStore();
    const { showSuccessToast, showErrorToast } = useToastWrapper({
        successMessage: "Default success message",
        errorMessage: "Default error message",
    });
    const { t } = useLocalizedString();
    const handleClose = () => {
        setEmailToRemove("");
        setRemoveError("");
        setIsValidationg(false);
        onClose();
    };
    const handleSubmit = async () => {
        if (emailToRemove !== email) {
            setRemoveError(t("Emails are different"));
            setIsValidationg(true);
            return;
        }
        setRemoveError("");
        setIsSubmitting(true);
        try {
            await adapter.DeleteEmail(email, profile.id);
            showSuccessToast(t("Your email has been successfully removed"));
            setIsSubmitting(false);
            removeEmail(email);
            updateInitialEmails();
            onEmailRemoved();
        }
        catch {
            showErrorToast(t("There was an error please try agian later"));
            handleClose();
        }
        finally {
        }
    };
    const updateEmail = (e) => {
        setEmailToRemove(e?.target?.value);
    };
    useEffect(() => {
        if (isValidating) {
            setRemoveError(emailToRemove !== email ? t("Emails are different") : "");
        }
    }, [emailToRemove]);
    return (_jsx(Modal, { isOpen: isOpen, onClose: handleClose, children: _jsxs("div", { className: "flex flex-col", children: [_jsx("div", { className: "flex flex-col w-[90%]", children: _jsxs("div", { className: "flex flex-col sm:flex-col gap-[20px] sm:items-right w-full", children: [_jsx("h3", { className: "text-[28px] sm:text-[36px] font-bold leading-tight sm:leading-[48px] w-full mb-2 sm:mb-0", children: t("Are you sure you want to remove your email?") }), _jsx("p", { className: "text-base leading-relaxed max-w-prose mb-2 break-all", children: _jsx(Sanitize, { html: t('Please type <span class="font-bold">{{email}}</span> to continue with removal:', {
                                        email: email,
                                        interpolation: { escapeValue: false },
                                    }) }) })] }) }), _jsx("div", { children: _jsx(InputField, { label: "Email", placeholder: "Email", value: emailToRemove, name: email, disabled: isSubmitting, readOnly: false, isLastElement: true, className: "w-full sm:px-0", onChange: updateEmail, error: removeError }) }), _jsx("div", { className: "w-full flex justify-end items-center mt-[20px]", children: _jsxs("div", { className: "flex items-center gap-8", children: [!isSubmitting && (_jsx(ClickableText, { "data-testid": "cancelButton", onClick: handleClose, children: t("Cancel") })), _jsx(Button, { "data-testid": "saveButton", variant: "primary", onClick: handleSubmit, disabled: isSubmitting, children: isSubmitting ? _jsx(Spinner, {}) : t("Continue") })] }) })] }) }));
};
export default RemoveEmailModal;
//# sourceMappingURL=RemoveEmailModal.js.map